// extracted by mini-css-extract-plugin
module.exports = {"DeliveryMap":"DeliveryMap_DeliveryMap__jwrQ6","root":"DeliveryMap_root__3JJI-","app":"DeliveryMap_app__3DQPA","map":"DeliveryMap_map__3NOpt"};